export default {
  key: "HrdcSettingsAttachment",
  serviceKey: "hrdc",
  name: {
    singular: "Attachment",
    plural: "Attachments",
  },
  parent_route: "HrdcSettings",
  add: {
    name: "Attachment",
  },
  view: {
    name: "Attachment",
  },
};
